import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatCodeSurfaceDefaultVariants = {
  "kind": "context"
}
const chatCodeSurfaceCompoundVariants = []

const chatCodeSurfaceSlotNames = [
  [
    "root",
    "chatCodeSurface__root"
  ],
  [
    "header",
    "chatCodeSurface__header"
  ],
  [
    "title",
    "chatCodeSurface__title"
  ],
  [
    "stat",
    "chatCodeSurface__stat"
  ],
  [
    "additions",
    "chatCodeSurface__additions"
  ],
  [
    "deletions",
    "chatCodeSurface__deletions"
  ],
  [
    "scroll",
    "chatCodeSurface__scroll"
  ],
  [
    "surface",
    "chatCodeSurface__surface"
  ],
  [
    "line",
    "chatCodeSurface__line"
  ],
  [
    "gutter",
    "chatCodeSurface__gutter"
  ]
]
const chatCodeSurfaceSlotFns = /* @__PURE__ */ chatCodeSurfaceSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatCodeSurfaceDefaultVariants, getSlotCompoundVariant(chatCodeSurfaceCompoundVariants, slotName))])

const chatCodeSurfaceFn = memo((props = {}) => {
  return Object.fromEntries(chatCodeSurfaceSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatCodeSurfaceVariantKeys = [
  "kind"
]
const getVariantProps = (variants) => ({ ...chatCodeSurfaceDefaultVariants, ...compact(variants) })

export const chatCodeSurface = /* @__PURE__ */ Object.assign(chatCodeSurfaceFn, {
  __recipe__: false,
  __name__: 'chatCodeSurface',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatCodeSurfaceVariantKeys,
  variantMap: {
  "kind": [
    "context",
    "added",
    "removed",
    "error"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chatCodeSurfaceVariantKeys)
  },
  getVariantProps
})